window.JobTitlesForm = function (jobTitlesDataService, formData) {
    var self = this;
    var allJobTitlesList = [];
    let shiftSelectedDate;
    self.data = self.data || {};
    self.data.job_titles = [];
    self.selectedJobTitles = [];
    self.mappedSelectedJobTitles = [];
    self.shiftStatus;
    self.comeFrom;
    self.userExtraJobTitle = {};
    self.currency = "";

    self.JOB_TITLE_INPUT_NAME = {
        STATIONS: 'STATIONS',
        STATION_START_TIME: 'STATION_START_TIME',
        STATION_END_TIME: 'STATION_END_TIME',
        DELETE_STATION: 'DELETE_STATION',
    }

    const setCurrency = function (currency) {
        self.currency = currency;
    };

    var setIsWendysLaborServiceEnabled = function (isEnabled) {
        self.isWendysLaborServiceEnabled = isEnabled;
    };
    var setJobTitlesSource = function (comeFrom) {
        self.comeFrom = comeFrom;
    };

    var setIsAssigneeShiftJobTitleTimesEnforced = function (isEnabled) {
        self.isAssigneeShiftJobTitleTimesEnforced = isEnabled;
    };
    var setBusinessDayLimits = function (bussnissDayLimit) {
        self.businessDayLimits = bussnissDayLimit;
    };

    const setShiftSelectedDate = (date) => {
        shiftSelectedDate = date;
    }

    var prepareBrandUserJobTitlesListOptions = (userId, positionsCode) => {
        userId = userId && parseInt(userId);
        var userJobTitles = (userId && jobTitlesDataService.usersJobTitles[userId]) || {};
        self.userExtraJobTitle = jobTitlesDataService.usersExtraJobMap[userId]?.[shiftSelectedDate] || {};
        self.brandUserJobTitles = [];
        var jobTitlesList = [];
        for (var i in jobTitlesDataService.brandJobTitles) {
            var jobTitleItem = jobTitlesDataService.brandJobTitles[i];
            var jobTitleLevel = userJobTitles[jobTitleItem.id] && userJobTitles[jobTitleItem.id].level;

            var itemToPush = angular.copy(jobTitleItem);
            itemToPush.name = jobTitleItem.name;
            if (!!userId) {
                itemToPush.name += " (" + (jobTitleLevel ? jobTitleLevel : "-") + ")";
                itemToPush.level = jobTitleLevel;
            }
            allJobTitlesList.push(itemToPush);
            if (itemToPush.status === "ACTIVE") {
                jobTitlesList.push(itemToPush);
            }
        }

        self.brandUserJobTitles = jobTitlesList.sort(function (a, b) {
            return a.weight - b.weight;
        });

        self.brandUserJobTitles = jobTitlesDataService.filterStationsPerPositions(self.brandUserJobTitles, positionsCode);
    };

    var mapJobTitles = function (selctedJobTitles) {
        var shiftJobTitles = [];
        var jobTitles = selctedJobTitles || [];
        self.selectedJobTitles = [];
        self.mappedSelectedJobTitles = [];
        for (var j in jobTitles) {
            var shiftJobTitle = jobTitles[j];
            var jobTitleItem = _.findWhere(jobTitlesDataService.brandJobTitles, {id: shiftJobTitle.job_title_id});
            if (jobTitleItem) {
                var selectedJobTitle = angular.copy(shiftJobTitle);
                selectedJobTitle.jobTitle = jobTitleItem;
                if (self.showJobTitleDrawManually()) {
                    var alreadyPushedJobTitle = self.mappedSelectedJobTitles.find(function (jobTitle) {
                        return jobTitle.id === shiftJobTitle.job_title_id;
                    });

                    if (!alreadyPushedJobTitle) {
                        var details = allJobTitlesList.find(function (item) {
                            return item.id === shiftJobTitle.job_title_id;
                        });

                        var pushedObj = $.extend(angular.copy(details), {slots: []});
                        pushedObj.slots.push({
                            start_time: selectedJobTitle.start_time,
                            end_time: selectedJobTitle.end_time
                        });

                        if (details && pushedObj) {
                            self.mappedSelectedJobTitles.push(pushedObj);
                            self.selectedJobTitles.push(angular.copy(details));
                        }
                    } else {
                        alreadyPushedJobTitle.slots.push(
                            {
                                start_time: selectedJobTitle.start_time,
                                end_time: selectedJobTitle.end_time
                            }
                        )
                    }
                } else {
                    selectedJobTitle.start_time = selectedJobTitle.start_time ? new Date(selectedJobTitle.start_time) : '';
                    selectedJobTitle.end_time = selectedJobTitle.end_time ? new Date(selectedJobTitle.end_time) : '';
                    shiftJobTitles.push(selectedJobTitle);
                }

            } else {
                console.warn("station not found id:", jobTitles[j].job_title_id);
            }
        }
        return shiftJobTitles;
    };

    var updateIntervalStartAndEndTime = function (interval) {
        self.interval = interval;
    };
    var updateJobTitlesEndTimeOptions = function () {
        var updatedJobTitles = [];
        for (var i in self.data.job_titles) {
            var shiftJobTitle = self.data.job_titles[i];
            shiftJobTitle.end_time_options = self.prepareJobTitleEndTimeOptions(shiftJobTitle, self.interval?.end_time);
            updatedJobTitles.push(shiftJobTitle);
        }
        self.data.job_titles = angular.copy(updatedJobTitles);
    };

    self.onDrawingJobTitles = function () {
        self.mappedSelectedJobTitles = [];
        for (var i in self.selectedJobTitles) {
            var jobTitle = self.selectedJobTitles[i];
            if (jobTitle.id) {
                self.mappedSelectedJobTitles.push(
                    {
                        id: jobTitle.id,
                        name: jobTitle.name,
                        color: jobTitle.color,
                        level: jobTitle.level
                    }
                )
            }
        }
        self.shiftStatus = 'UNPUBLISHED';
        formData?.templateDataChanged?.();
    };

    self.initJobTitles = function (shiftJobTitles) {
        self.data.job_titles = [];
        for (var i in shiftJobTitles) {
            shiftJobTitles[i].end_time_options = self.prepareJobTitleEndTimeOptions(shiftJobTitles[i], self.interval?.end_time);
            self.data.job_titles.push(shiftJobTitles[i]);
        }
        if (self.isAssigneeShiftJobTitleTimesEnforced && self.brandUserJobTitles.length && self.data.job_titles.length == 0) {
            self.addNewShiftJobTitle();
        }
    };

    self.validateJobTitles = function () {
        self.validator.validate();
    };

    self.showJobTitleDrawManually = function () {
        return self.isWendysLaborServiceEnabled || showJobTitleDrawManuallyForSpecificBrands();
    };

    self.addNewShiftJobTitle = function () {
        self.data.job_titles = self.data.job_titles || [];
        const jobTitleObject = {};
        const shiftEndTime = self.interval?.end_time;

        if (self.isAssigneeShiftJobTitleTimesEnforced) {
            if (self.data.job_titles.length &&
                self.data.job_titles[self.data.job_titles.length - 1] &&
                self.data.job_titles[self.data.job_titles.length - 1].end_time &&
                self.data.job_titles[self.data.job_titles.length - 1].end_time.valueOf() !== shiftEndTime.valueOf()
            ){
                jobTitleObject['start_time'] = self.data.job_titles[self.data.job_titles.length - 1].end_time;
                self.jobTitlesDetailsChanged(jobTitleObject);
            } else {
                jobTitleObject['start_time'] = self.data.startTime;
            }
        }

        self.data.job_titles.push(jobTitleObject);
        self.shiftStatus = 'UNPUBLISHED';
    };

    var getJobtitlesData = function () {
        var dataToSave;
        if (self.showJobTitleDrawManually()) {
            dataToSave = angular.copy(jobTitlesDataService.getFormattedJobTitles());
        }
        else {
            dataToSave = self.data.job_titles;
        }
        return dataToSave;
    };

     const isJobTitleNotEligible = (jobTitleId, selectedPositions) => {
         const jobTitle = self.data.job_titles?.find((jobTitle) => (jobTitle.id === jobTitleId))?.jobTitle;

         const selectedPositionsCodes = selectedPositions?.map(position => position.code) ?? [];
         const positionsCodes = (jobTitle?.positions || [])?.map(position => position.code) ?? [];

         for (const positionCode of selectedPositionsCodes) {
             if (positionsCodes.length === 0 || positionsCodes.includes(positionCode)) {
                 return false;
             }
         }

         return true;
     };

    self.deleteShiftJobTitle = function (index) {
        self.data.job_titles.splice(index, 1);
        self.shiftStatus = 'UNPUBLISHED';
        if (!self.data.job_titles.length && self.isAssigneeShiftJobTitleTimesEnforced) {
            self.addNewShiftJobTitle();
        }
        formData?.templateDataChanged?.();
    };

    self.onTimeChangeValidate = function (target) {
        return function (value) {
            if (value && value.isValid()) {
                if (value.isBefore(self.businessDayLimits.openTime)) {
                    value.add(1, 'day');
                }
                if (value.isAfter(self.businessDayLimits.closeTime)) {
                    value.subtract(1, 'day');
                }
                if (target == 'from') {
                    if (value.isAfter(self.businessDayLimits.closeTime)) {
                        value = self.businessDayLimits.openTime;
                    }
                } else if (target == 'to') {
                    if (value.isBefore(self.businessDayLimits.openTime)) {
                        value = self.businessDayLimits.closeTime;
                    }
                }
            }
            return value;
        }
    };

    self.onJobTitleTimeOptionSelect = function (target, interval) {
        return function (option) {
            var metaObj = {};
            if (option.next_day) {
                metaObj.appendText = $filter('translate')('Next Day');
                metaObj.prependIcon = 'next-day-icon';
            } else {
                metaObj.appendText = '';
                metaObj.prependIcon = '';
            }

            if (interval) {
                interval[target + '_meta'] = metaObj;
            } else {
                self[target + '_meta'] = metaObj;
            }
        }
    };
    var isJobTitleStartAndEndTimeSet = function (jobTitleItem, attribute) {
        var otherValue;
        var value;
        if (jobTitleItem) {
            if (attribute === "job_title_start_time") {
                otherValue = jobTitleItem.end_time;
                value = jobTitleItem.start_time;

            } else if (attribute === "job_title_end_time") {
                otherValue = jobTitleItem.start_time;
                value = jobTitleItem.end_time;
            }

            return !(otherValue && !value);
        }
        return false;

    };

    self.jobTitlesDetailsChanged = function (shiftJobTitle) {
        self.shiftStatus = 'UNPUBLISHED';
        shiftJobTitle.end_time_options = self.prepareJobTitleEndTimeOptions(shiftJobTitle, self.interval?.end_time);
        formData?.templateDataChanged?.();
    };

    var showJobTitleDrawManuallyForSpecificBrands = function () {
        var brandIds = [self.brand.parent_id, self.brand.id];
        var isTcgEnabled = false;

        //first 4 brands is dev brands
        // 5th one for staging sanity
        for (var i in brandIds) {
            isTcgEnabled = [
                10125341,
                10146341,
                10145530,
                10146342,
                4070285,
                4586779,
                4586811,
                4586838,
                4586858,
                4586897,
            ].indexOf(brandIds[i]) > -1;

            if (isTcgEnabled) {
                return true;
            }
        }

        return isTcgEnabled;
    };

    return {
        updateJobTitlesEndTimeOptions: updateJobTitlesEndTimeOptions,
        mapJobTitles: mapJobTitles,
        prepareBrandUserJobTitlesListOptions: prepareBrandUserJobTitlesListOptions,
        setIsWendysLaborServiceEnabled: setIsWendysLaborServiceEnabled,
        setIsAssigneeShiftJobTitleTimesEnforced: setIsAssigneeShiftJobTitleTimesEnforced,
        setBusinessDayLimits: setBusinessDayLimits,
        setShiftSelectedDate: setShiftSelectedDate,
        updateIntervalStartAndEndTime: updateIntervalStartAndEndTime,
        getJobtitlesData: getJobtitlesData,
        isJobTitleStartAndEndTimeSet: isJobTitleStartAndEndTimeSet,
        isJobTitleNotEligible: isJobTitleNotEligible,
        setCurrency: setCurrency,
    };
};